import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { APTermCourseDataQueryhelper } from '../../plan/queries/ap_term_course_data_query_helper';
import { APCourse } from '../builders/ap_course_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../builders/ap_planned_course_builder';
import { APTerm } from '../builders/ap_term_builder';
import { APPlannedCourseServant } from './../servants/ap_planned_course_servant';
import { IAPCoursesDatasource } from './ap_courses_datasource';
import { IAPSectionTypeDatasource } from './ap_section_type_datasource';
import { IAPTermsDatasource } from './ap_terms_datasource';
export interface IAPPlannedCourseDataSource extends IDatasource<APPlannedCourse, {}, IAPPlannedCourseMeta> {}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'ngAPPlannedCoursesDatasource',
    (
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPSectionTypeDatasource: IAPSectionTypeDatasource,
      ngAPTermsDatasource: IAPTermsDatasource
    ) => {
      return new Datasource<APPlannedCourse, {}, IAPPlannedCourseMeta>({
        builderType: APPlannedCourse,
        updateMode: 'merge'
      }).includeMetasource<IAPPlannedCourseMeta>((datasource) => {
        return new Metasource<APPlannedCourse, IAPPlannedCourseMeta>(datasource)
          .includeOneToMany(
            '_course',
            ngAPCoursesDatasource,
            'course',
            (plannedCourse: APPlannedCourse, course: APCourse) => {
              course.is_planned = true;
              course.credits = course.credits || 0;
              return course;
            }
          )
          .includeAttributes((plannedCourse) => {
            const course = ngAPCoursesDatasource.get(plannedCourse.course);
            const sectionTypeKeys = course ? course.section_types : [];
            const sections = _4.sortBy(
              _4.uniq(
                _4.filter(
                  _4.map(sectionTypeKeys, (key: number) => ngAPSectionTypeDatasource.get(key)),
                  (sctnType) => sctnType && sctnType.term === plannedCourse.term
                )
              ),
              ['rank']
            );
            return {
              _section_type_keys: sectionTypeKeys,
              _section_types: sections,
              _hasMultiSections: sections.length > 1
            };
          })
          .includeAttribute('_multiSectionLabels', (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) =>
            APPlannedCourseServant.multiSectionLabels(plannedCourse)
          )
          .includeAttribute('_hasRequisiteProblem', (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) =>
            APPlannedCourseServant.hasRequisiteProblem(plannedCourse)
          )
          .includeAttribute('_hasCourseOfferedProblem', (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) =>
            APPlannedCourseServant.hasCoursesOfferedProblem(plannedCourse)
          )
          .includeAttribute(
            '_hasCoReq',
            (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) =>
              _4.get(plannedCourse, '_course.coreq.length', 0) > 0
          )
          .includeAttribute('_hasPreReq', (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) => {
            return _4.some(['prereq_outoforder', 'prereq_miss'], (key) => plannedCourse[key].length > 0);
          })
          .includeManyToMany('_coreq_miss', ngAPCoursesDatasource, 'coreq_miss')
          .includeManyToMany('_coreq_outoforder', ngAPCoursesDatasource, 'coreq_outoforder')
          .includeManyToMany('_prereq_miss', ngAPCoursesDatasource, 'prereq_miss')
          .includeManyToMany('_prereq_outoforder', ngAPCoursesDatasource, 'prereq_outoforder')
          .includeAttribute(
            '_coreq',
            (plannedCourse: APPlannedCourse & IAPPlannedCourseMeta) =>
              _4.compact(
                _4.map(_4.get(plannedCourse, '_course.coreq', []), (reqId: number) => ngAPCoursesDatasource.get(reqId))
              ) as APCourse[]
          );
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_planned_course_datasource.ts